import { Modal, Form, Input } from "antd";

import Button from "antd-button-color";

const RESET = "reset";
const RESEND = "resend";

const ExtraAuth = ({ visible, onClose, switchHandler, type }) => {
  return (
    <>
      <Modal
        centered
        title=" "
        zIndex="1030"
        footer={null}
        onOk={onClose}
        visible={visible}
        onCancel={onClose}
        maskClosable={false}
        className="modal-auth"
        closeIcon={<i className="far fa-times" />}
      >
        <h4 className="fs-20-s">
          {type === RESET && "Atur ulang kata sandi"}
          {type === RESEND && "Kirim ulang email verifikasi"}
        </h4>
        <p className="text-muted fs-12-s">
          {type === RESET &&
            "Masukkan e-mail yang terdaftar. Kami akan mengirimkan link untuk atur ulang kata sandi."}
          {type === RESEND &&
            "Masukkan e-mail yang terdaftar. Kami akan mengirimkan link verifikasi terbaru."}
        </p>

        <Form layout="vertical" name="login" className="mt-4">
          <Form.Item label="Email" className="mb-3">
            <Input name="email" type="email" placeholder="Email" />
          </Form.Item>

          <Form.Item className="mb-3">
            <Button type="dark" block>
              Kirim
            </Button>
          </Form.Item>
        </Form>

        <p className="text-muted mb-0 fs-12">
          Belum punya akun?
          <Button type="link" className="px-0 m-l-3" onClick={switchHandler}>
            Daftar
          </Button>
        </p>
      </Modal>
    </>
  );
};

export default ExtraAuth;
